module.exports = __webpack_public_path__ + "img/pantalla-6-4.8886ae00.png";